import { useNavigate, useParams } from 'react-router-dom';
import './oildetail.css';

const carealsData = {
  soyasmall: {
    name: 'Soya Chunks Small',
    image: '/images/careals/soyachunksmall.webp',
    description:
      'Small Soya Chunks, known as Soya Urundai (சோயா உருண்டை) in Tamil, are protein-rich nuggets made from defatted soybean flour. Though not native to Tamil cuisine, they’re widely used in dishes like kurma, biryani, and poriyal for their meaty texture and nutrition. Rich in protein, iron, and fiber, they support muscle growth, heart health, and are ideal for kids and fitness-focused diets.',
  },
  soyabig: {
    name: 'Soya Chunks Big',
    image: '/images/careals/soyachunkbig.webp',
    description:
      'Big Soya Chunks, known as Periya Soya Urundai (பெரிய சோயா உருண்டை), are modern protein staples in Tamil kitchens. Used in gravies, biryani, and kurma, they are valued for their dense texture and nutrition. Rich in plant protein and fiber, they help improve stamina, build strength, and provide fullness—making them a favorite in vegetarian and health-conscious diets.',
  },
  redthin: {
    name: 'Red Rice Cereals Thin',
    image: '/images/careals/thin.webp',
    description:
      'Thin Red Rice Cereals, or Sivappu Arisi Thinai (சிவப்பு அரிசி தினை), are made from finely flaked red rice grown in Thanjavur and Trichy. Used in kanji, porridge, or upma, they are rich in iron, fiber, and antioxidants. Believed to boost blood health and support digestion, they offer a light, energizing start to the day.',
  },
  redthick: {
    name: 'Red Rice Cereals Thick',
    image: '/images/careals/thick.webp',
    description:
      'Thick Red Rice Cereals, or Sivappu Arisi Aval (சிவப்பு அரிசி அவல்), are hearty red rice flakes cultivated in regions like Thanjavur and Theni. Used in upma, kozhukattai, or sweet snacks, they retain more bran and fiber. Rich in iron, they aid digestion and boost hemoglobin—ideal for wholesome Tamil breakfasts.',
  },
  whitethin: {
    name: 'White Rice Cereals Thin',
    image: '/images/careals/whitericeflakesthin.webp',
    description:
      'Thin White Rice Cereals, or Vellai Arisi Aval (வெள்ளை அரிசி அவல்), are made from polished white rice from places like Kumbakonam and Villupuram. These light, soft flakes are used in upma, sweet aval, or soaked in milk. Easy to digest and gentle on the stomach, they’re ideal for elders, children, and recovery diets.',
  },
  whitethick: {
    name: 'White Rice Cereals Thick',
    image: '/images/careals/whitericeflakesthick.webp',
    description:
      'Thick White Rice Cereals, or Periya Vellai Aval (பெரிய வெள்ளை அவல்), are made from parboiled rice and used in dishes like lemon aval, pongal, or aval kozhukattai. These flakes are filling and digestible, providing instant energy and making them perfect for traditional Tamil breakfasts and snacks.',
  },
  puffedrice: {
    name: 'Puffed Rice',
    image: '/images/careals/puffedrice.webp',
    description:
      'Puffed Rice, or Pori (பொறி) in Tamil, is made by puffing parboiled rice, a process common in regions like Thanjavur and Cuddalore. Used in snacks like kara pori, sweet pori, or eaten with milk, it’s light, low in calories, and believed to cool the body—making it ideal for summer and fasting days.',
  },
  kavuniaval: {
    name: 'Karuppu Kavuni Aval',
    image: '/images/careals/kavuniaval.webp',
    description:
      'Karuppu Kavuni Aval (கருப்பு கவ்வுநி அவல்) is made from ancient black Kavuni rice once served to Chola kings. Grown in regions like Thanjavur and Ramanathapuram, these flakes are used in sweet dishes, kanji, or with milk and coconut. Rich in antioxidants and iron, they are believed to purify blood, build stamina, and support skin and hair health.',
  },
  mapillaisamba: {
    name: 'Mapillai Samba Aval',
    image: '/images/careals/mapillaisambaaval.webp',
    description:
      'Mapillai Samba Aval (மாப்பிள்ளை சம்பா அவல்) is made from the traditional red rice given to grooms in Tamil weddings. Sourced from Thanjavur and Trichy, it is used in upma, porridge, or sweets. Rich in iron and fiber, it supports stamina, digestion, and is ideal for balanced, energy-rich Tamil diets.',
  },
};




const CarealDetail = () => {
  const { type } = useParams();
  const item = carealsData[type];
  const navigate = useNavigate();
  const goToProducts = () => {
        navigate('/cereals');
    };

  if (!item) return <h2>Flakes product not found</h2>;

  return (
    <section
      className="sesame-section"
      style={{ backgroundImage: `url(${item.image})` }}
    >
      <div className="sesame-content">
        <div className="text-content">
          <button className='back-btn-viewmore' onClick={goToProducts}>⟵ Back to Cereals Products</button>
          <h2>{item.name}</h2>
          <p>{item.description}</p>
        </div>
        <div className="button-box">
          <button className="enquire-btn">ENQUIRE NOW</button>
        </div>
      </div>
    </section>
  );
};

export default CarealDetail;
